// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"170":"70e2cf81","260":"910d9e30","613":"d25b9031","659":"69e0b697"}[chunkId] + ".js";
};